(() => {
  if (customElements.get('sissilux-blog-library')) return;
  class BlogLibrary extends HTMLElement {
    async connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.initialPath = location.pathname;
      this.dictionary = JSON.parse(this.querySelector('[data-dictionary]').textContent);
      this.grid = this.querySelector('[data-grid]');
      this.form = this.querySelector('form');
      this.input = this.form.elements.q;
      this.dialog = this.querySelector('dialog');
      this.form.addEventListener('submit', e => { e.preventDefault(); if(this.loaded) this.update({q:this.input.value.trim(), page:1}); });
      try {
        const base = new URL(this.dataset.base, location.origin);
        const preview = new URL(location.href).searchParams.get('preview_theme_id');
        if (preview) base.searchParams.set('preview_theme_id', preview);
        base.searchParams.set('section_id', this.dataset.section);
        let root = this;
        if (location.pathname.includes('/tagged/') || new URL(location.href).searchParams.has('page')) root = await this.fetchRoot(base);
        const cards = [...root.querySelectorAll('[data-grid] > [data-id]')];
        let next = root.querySelector('[data-next-batch]');
        const visited = new Set();
        while (next) {
          const url = new URL(next.href, location.origin);
          url.searchParams.set('section_id', this.dataset.section);
          if (preview) url.searchParams.set('preview_theme_id', preview);
          if (visited.has(url.href)) throw new Error('Repeated page');
          visited.add(url.href);
          root = await this.fetchRoot(url);
          cards.push(...root.querySelectorAll('[data-grid] > [data-id]'));
          next = root.querySelector('[data-next-batch]');
        }
        const seen = new Set();
        this.cards = cards.filter(card => { if(seen.has(card.dataset.id)) return false; seen.add(card.dataset.id); return true; }).map(card => ({node:card,tags:card.dataset.tags.split('||').filter(Boolean),text:(card.dataset.search || card.textContent).toLocaleLowerCase()}));
        this.grid.replaceChildren(...this.cards.map(c => c.node));
        this.createFilters();
        this.loaded = true;
        this.querySelector('[data-enhanced]').hidden = false;
        this.readState();
        this.render();
        this.querySelectorAll('[data-topic]').forEach(a => a.addEventListener('click', e => { if(e.ctrlKey||e.metaKey||e.shiftKey||e.altKey) return; e.preventDefault(); this.update({Topic:a.dataset.topic,Body:'',Need:'',page:1}); }));
        this.querySelector('[data-topic-select]').addEventListener('change', e => this.update({Topic:e.target.value,Body:'',Need:'',page:1}));
        this.querySelectorAll('[data-clear]').forEach(b => b.addEventListener('click', () => this.update({Topic:'',Body:'',Need:'',Type:'',q:'',page:1})));
        this.querySelector('[data-open-filters]').addEventListener('click', () => {this.opener=document.activeElement; this.dialog.showModal();});
        this.querySelectorAll('[data-close-filters]').forEach(b => b.addEventListener('click', () => this.dialog.close()));
        this.dialog.addEventListener('click', e => { if(e.target === this.dialog) {const r=this.dialog.getBoundingClientRect(); if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)this.dialog.close();} });
        this.dialog.addEventListener('close', () => this.opener?.focus());
        this.input.addEventListener('search', () => this.update({q:this.input.value.trim(),page:1}));
        this.onPop = () => { this.readState(); this.render(); };
        window.addEventListener('popstate', this.onPop);
        this.onHash = () => {this.readState();this.render();};
        window.addEventListener('hashchange', this.onHash);
      } catch(e) { this.querySelector('[data-error]').hidden=false; console.error('Blog library load:',e); }
    }
    disconnectedCallback(){window.removeEventListener('popstate',this.onPop);window.removeEventListener('hashchange',this.onHash);}
    async fetchRoot(url){const r=await fetch(url,{credentials:'same-origin'});if(!r.ok)throw new Error('Library request '+r.status);const doc=new DOMParser().parseFromString(await r.text(),'text/html');const root=doc.querySelector('sissilux-blog-library');if(!root)throw new Error('Missing library');return root;}
    createFilters(){
      for(const [target,suffix] of [['[data-desktop-filters]','desktop'],['[data-drawer-filters]','drawer']]) {
        const host=this.querySelector(target);
        for(const key of ['Body','Need','Type']) {
          const label=document.createElement('label');label.textContent={Body:'Body area',Need:'Need or routine',Type:'Content type'}[key];
          const select=document.createElement('select');select.dataset.dimension=key;select.id=`${this.dataset.section}-${key}-${suffix}`;label.htmlFor=select.id;
          select.addEventListener('change',()=>this.update({[key]:select.value,page:1}));label.append(select);host.append(label);
        }
      }
    }
    readState(){
      const p=new URLSearchParams(location.hash.slice(1));
      const initial=JSON.parse(this.querySelector('[data-current-tags]').textContent)||[];
      // Derive the topic from the URL on every navigation, not stale initial markup.
      const topic=[...this.querySelectorAll('[data-topic]')].find(a=>a.dataset.topic&&new URL(a.href).pathname===location.pathname)?.dataset.topic||'';
      this.state={Topic:topic,Body:'',Need:'',Type:'',q:p.get('q')||'',page:Math.max(1,parseInt(p.get('page'),10)||1)};
      for(const key of ['Topic','Body','Need','Type']) {const value=p.get(key)||'';if(this.dictionary[key].includes(value))this.state[key]=value;}
      // Native multi-tag links remain valid entrances.
      if(!location.hash && location.pathname===this.initialPath && location.pathname.includes('/tagged/'))for(const tag of initial){const [key,...rest]=tag.split(': ');const value=rest.join(': ');if(this.dictionary[key]?.includes(value))this.state[key]=value;}
    }
    update(patch){
      Object.assign(this.state,patch);
      const url=new URL(location.href);
      const topicLink=[...this.querySelectorAll('[data-topic]')].find(a=>a.dataset.topic===this.state.Topic);
      url.pathname=topicLink?new URL(topicLink.href).pathname:this.dataset.base;
      url.searchParams.delete('page');
      const hash=new URLSearchParams();
      for(const key of ['Body','Need','Type','q'])if(this.state[key])hash.set(key,this.state[key]);
      if(this.state.page>1)hash.set('page',this.state.page);
      url.hash=hash.toString();
      if(url.href!==location.href)history.pushState(null,'',url);
      this.render();
    }
    render(){
      const s=this.state;
      const topicCards=this.cards.filter(c=>!s.Topic||c.tags.includes('Topic: '+s.Topic));
      for(const key of ['Body','Need','Type']) {
        const available=this.dictionary[key].filter(v=>topicCards.some(c=>c.tags.includes(key+': '+v)));
        if(s[key]&&!available.includes(s[key]))s[key]='';
        this.querySelectorAll(`[data-dimension="${key}"]`).forEach(select=>{const options=[new Option('All '+{Body:'body areas',Need:'needs',Type:'types'}[key],'')];options.push(...available.map(v=>new Option(v,v)));select.replaceChildren(...options);select.value=s[key];});
      }
      const words=s.q.toLocaleLowerCase().split(/\s+/).filter(Boolean);
      const results=topicCards.filter(c=>['Body','Need','Type'].every(k=>!s[k]||c.tags.includes(k+': '+s[k]))&&words.every(w=>c.text.includes(w)));
      const pages=Math.max(1,Math.ceil(results.length/12));s.page=Math.min(s.page,pages);
      this.cards.forEach(c=>{c.node.hidden=true;});results.slice((s.page-1)*12,s.page*12).forEach(c=>{c.node.hidden=false;});
      this.querySelector('[data-count]').textContent=`${results.length} ${results.length===1?'guide':'guides'}`;
      this.querySelector('[data-empty]').hidden=results.length>0;
      this.input.value=s.q;
      this.querySelector('[data-topic-select]').value=s.Topic;
      this.querySelectorAll('[data-topic]').forEach(a=>{if(a.dataset.topic===s.Topic)a.setAttribute('aria-current','page');else a.removeAttribute('aria-current');});
      const nav=this.querySelector('[data-pagination]');nav.replaceChildren();
      if(pages>1)for(let page=1;page<=pages;page++) {const a=document.createElement('a');a.textContent=page;const u=new URL(location.href);const h=new URLSearchParams(u.hash.slice(1));if(page>1)h.set('page',page);else h.delete('page');u.hash=h.toString();a.href=u.href;if(page===s.page)a.setAttribute('aria-current','page');a.addEventListener('click',e=>{if(e.ctrlKey||e.metaKey||e.shiftKey||e.altKey)return;e.preventDefault();this.update({page});this.querySelector('[data-count]').scrollIntoView({block:'center'});});nav.append(a);}
    }
  }
  customElements.define('sissilux-blog-library',BlogLibrary);
})();
